module.exports = __webpack_public_path__ + "img/icons.d1527a65.svg";